    import { create } from "zustand";
    import { PDA1100_R01Dto } from "./PDA1100_R01Dto";

    /**
     * PDA1100_R01 자재 저장위치 등록 Store
     */
    export interface PDA1100_R01Store {
    // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    // 입력 상태
    // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    scanValue: string;              // 스캔 입력값
    newLocationCd: string;          // 새 저장위치 입력값

    // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    // 조회 데이터
    // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    data: PDA1100_R01Dto | null;    // 조회된 품목 정보

    // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    // 로딩 상태
    // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    loading: boolean;

    // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    // Actions
    // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    setScanValue: (value: string) => void;
    setNewLocationCd: (value: string) => void;
    setData: (data: PDA1100_R01Dto | null) => void;
    setLoading: (loading: boolean) => void;

    // 초기화
    reset: () => void;
    resetForm: () => void;
    }

    const usePDA1100_R01Store = create<PDA1100_R01Store>((set) => ({
    // 초기값
    scanValue: "",
    newLocationCd: "",
    data: null,
    loading: false,

    // Actions
    setScanValue: (value) => set({ scanValue: value }),
    setNewLocationCd: (value) => set({ newLocationCd: value }),
    setData: (data) => set({ data }),
    setLoading: (loading) => set({ loading }),

    // 전체 초기화
    reset: () =>
        set({
        scanValue: "",
        newLocationCd: "",
        data: null,
        loading: false,
        }),

    // 폼만 초기화 (저장 후 스캔 필드로 포커스)
    resetForm: () =>
        set({
        scanValue: "",
        newLocationCd: "",
        data: null,
        }),
    }));

    export default usePDA1100_R01Store;
